import React from 'react';

import {
  Select,
  MenuItem,
  SelectChangeEvent,
  OutlinedInput,
  Typography,
} from '@mui/material';
import { SheetStatus } from 'src/common/types/SaveSheet';

import { ReactComponent as DownIcon } from '../../../../common/assets/icons/chevron_down_icon.svg';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  disableScrollLock: true,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

type StatusOptionType = {
  label: string;
  value: SheetStatus | undefined;
};

const STATUSES: StatusOptionType[] = [
  {
    label: 'All Statuses',
    value: undefined,
  },
  {
    label: SheetStatus.UPLOADED,
    value: SheetStatus.UPLOADED,
  },
  {
    label: SheetStatus.PROCESSED,
    value: SheetStatus.PROCESSED,
  },
  {
    label: SheetStatus.DRAFT,
    value: SheetStatus.DRAFT,
  },
  {
    label: SheetStatus.FINALIZED,
    value: SheetStatus.FINALIZED,
  },
];

type Props = {
  value: SheetStatus | undefined;
  onChange: (status: SheetStatus | undefined) => void;
};

const getInitialStatus = (value: SheetStatus | undefined) => {
  const status = STATUSES.find((status) => status.value === value);
  return status ?? STATUSES[0];
};

const NoteStatusFilter: React.FC<Props> = ({ onChange, value }) => {
  const selectRef = React.useRef<HTMLSelectElement>(null);
  const [selectedStatus, setSelectedStatus] = React.useState<StatusOptionType>(
    getInitialStatus(value)
  );

  React.useEffect(() => {
    if (selectedStatus) onChange(selectedStatus.value);
  }, [onChange, selectedStatus]);

  const handleChange = (event: SelectChangeEvent<typeof selectedStatus>) => {
    const {
      target: { value },
    } = event;
    if (value && typeof value === 'object') setSelectedStatus(value);
  };

  return (
    <Select
      ref={selectRef}
      color='secondary'
      value={selectedStatus}
      onChange={handleChange}
      input={
        <OutlinedInput
          sx={{
            height: '40px',
            borderRadius: '40px',
            pr: '8px',
            width: { xs: '100%', sm: '180px' },
            backgroundColor: '#ffffff',
          }}
        />
      }
      renderValue={(selected) => {
        if (!!!selected) {
          return (
            <Typography color={'secondary'}>
              Status: {STATUSES[0].label}
            </Typography>
          );
        }
        return (
          <Typography color={'secondary'}>Status: {selected.label}</Typography>
        );
      }}
      IconComponent={() => (
        <DownIcon
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            right: '12px',
          }}
        />
      )}
      MenuProps={MenuProps}
    >
      {STATUSES.map((result) => (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        <MenuItem key={result.label} value={result as any}>
          <Typography>{result.label}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
};

export default NoteStatusFilter;
